import { render, staticRenderFns } from "./FigmaAPICallback.vue?vue&type=template&id=8d718590&scoped=true&"
import script from "./FigmaAPICallback.vue?vue&type=script&lang=js&"
export * from "./FigmaAPICallback.vue?vue&type=script&lang=js&"
import style0 from "./FigmaAPICallback.vue?vue&type=style&index=0&id=8d718590&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d718590",
  null
  
)

export default component.exports